'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isNumber = require('hs-lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isNewSignupUx = require('../utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

var _Config = require('../selectors/Config');

var _LoginOrExistingUserLink = require('../routeHandlers/UserRegistration/LoginOrExistingUserLink');

var _LoginOrExistingUserLink2 = _interopRequireDefault(_LoginOrExistingUserLink);

var _StepIndicator = require('./StepIndicator');

var _StepIndicator2 = _interopRequireDefault(_StepIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepHeader = exports.StepHeader = function (_React$Component) {
  _inherits(StepHeader, _React$Component);

  function StepHeader() {
    _classCallCheck(this, StepHeader);

    return _possibleConstructorReturn(this, (StepHeader.__proto__ || Object.getPrototypeOf(StepHeader)).apply(this, arguments));
  }

  _createClass(StepHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hasLoginLink = _props.hasLoginLink,
          totalSteps = _props.totalSteps,
          stepNumber = _props.stepNumber;


      if (!(0, _isNewSignupUx2.default)() || (0, _Config.getIsEmbeddedContentFlow)()) {
        return null;
      }

      if (!(0, _isNumber2.default)(totalSteps) || !(0, _isNumber2.default)(stepNumber)) {
        return null;
      }

      var maybeLoginLink = hasLoginLink ? _react2.default.createElement(
        'div',
        { className: 'login-link-container' },
        _react2.default.createElement(_LoginOrExistingUserLink2.default, null)
      ) : null;

      return _react2.default.createElement(
        'div',
        { className: 'step-header position-relative' },
        maybeLoginLink,
        _react2.default.createElement(_StepIndicator2.default, { current: stepNumber + 1, total: totalSteps })
      );
    }
  }]);

  return StepHeader;
}(_react2.default.Component);

StepHeader.propTypes = {
  hasLoginLink: _propTypes2.default.bool.isRequired,
  totalSteps: _propTypes2.default.number.isRequired,
  stepNumber: _propTypes2.default.number
};
exports.default = StepHeader;